import { render, staticRenderFns } from "./SelfCheckTarget.vue?vue&type=template&id=2554bf61&"
import script from "./SelfCheckTarget.vue?vue&type=script&lang=js&"
export * from "./SelfCheckTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SelfCheckTarget.vue"
export default component.exports